import { render, staticRenderFns } from "./TimeGuruVip.vue?vue&type=template&id=b246d8f6&scoped=true"
import script from "./TimeGuruVip.vue?vue&type=script&lang=js"
export * from "./TimeGuruVip.vue?vue&type=script&lang=js"
import style0 from "./TimeGuruVip.vue?vue&type=style&index=0&id=b246d8f6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b246d8f6",
  null
  
)

export default component.exports